/* global Cookies, attachEvent,slideUp, slideDown */

const allowedCookies = [];
const advanceCookieElement = document.querySelector('.advance-cookie-banner-wrapper');

function setCookie(element) {
  const cookieValue = element.value === 'yes' || element.checked ? 'cookie-set' : 'cookie-not-set';
  Cookies.set('advance-cookie-banner-seen', cookieValue, { expires: 7 });
}

if (advanceCookieElement) {
  if (!Cookies.get('advance-cookie-banner-seen')) {
    advanceCookieElement.classList.add('cookie-not-set');
  }

  // eslint-disable-next-line no-unused-vars
  attachEvent('.btn--cookie', 'click', (ev) => {
    ev.preventDefault();
    const checkboxes = document.querySelectorAll('.advance-cookie-modal__switcher-checkbox input');
    checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        allowedCookies.push(checkbox.id);
      }
    });
    allowedCookies.push('cookie-set');
    Cookies.set('cookie-banner-seen', allowedCookies, { expires: 7 });
    // eslint-disable-next-line no-restricted-globals
    location.reload();
  });
}

// *******************************************************************************
// 1.0 - Cookie banner details toggle
// *******************************************************************************

attachEvent('.advance-cookie-banner__detail-btn', 'click', (ev) => {
  const advanceDetailsBtn = ev.target.closest('.advance-cookie-banner');
  const advanceDetailsDropdown = advanceDetailsBtn.querySelector('.advance-cookie-banner__details');

  if (advanceDetailsBtn.classList.contains('is-open-details')) {
    slideUp(advanceDetailsDropdown, 400);
    advanceDetailsBtn.classList.remove('is-open-details');
  } else {
    advanceDetailsBtn.classList.add('is-open-details');
    slideDown(advanceDetailsDropdown, 400);
  }
});

// *******************************************************************************
// 1.2 - Open modal
// *******************************************************************************

attachEvent('.advance-cookie-modal-toggle-btn', 'click', (ev) => {
  ev.preventDefault();
  const cookieParentModalElem = ev.target.closest('.advance-cookie-banner-wrapper');
  cookieParentModalElem.querySelector('.advance-cookie-modal').classList.add('is-open-modal');
});

attachEvent('.advance-cookie-modal__close-btn', 'click', (ev) => {
  ev.preventDefault();
  ev.target.closest('.advance-cookie-modal').classList.remove('is-open-modal');
});

// *******************************************************************************
// 2.0 - Close Modal When Escape Key Press
// *******************************************************************************

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    const modalEle = document.querySelector('.advance-cookie-modal');
    modalEle.classList.remove('is-open-modal');
  }
});

// *******************************************************************************
// 3.0 - Close Modal When Click Out
// *******************************************************************************

document.addEventListener('click', (evt) => {
  const modalInner = document.querySelector('.advance-cookie-modal__inner');
  const toggleBtnEle = document.querySelector('.advance-cookie-modal-toggle-btn');
  let targetElement = evt.target; // clicked element

  do {
    // eslint-disable-next-line max-len
    if (targetElement === modalInner || targetElement === toggleBtnEle) {
      return;
    }
    targetElement = targetElement.parentNode;
  } while (targetElement);

  if (document.querySelector('.advance-cookie-modal')) {
    const modalEle = document.querySelector('.advance-cookie-modal');
    modalEle.classList.remove('is-open-modal');
  }
});

attachEvent('.advance-cookie-banner__close', 'click', (ev) => {
  Cookies.remove('cookie-banner-seen', 'cookie-set', { expires: 7 });
  advanceCookieElement.classList.remove('cookie-not-set');
  ev.preventDefault();
  const cookieBanner = document.querySelector('.advance-cookie-banner');
  slideUp(cookieBanner, 400);
});

attachEvent('.advance-cookie-modal__footer .btn--allow', 'click', (ev) => {
  const checkboxes = document.querySelectorAll('.advance-cookie-modal__switcher-checkbox input');
  checkboxes.forEach((checkbox) => {
    allowedCookies.push(checkbox.id);
  });
  Cookies.set('cookie-banner-seen', allowedCookies, { expires: 7 });
  // eslint-disable-next-line no-restricted-globals
  location.reload();
});

attachEvent('.advance-cookie-modal__footer .btn--confirm-choice', 'click', (ev) => {
  const checkboxes = document.querySelectorAll('.advance-cookie-modal__switcher-checkbox input');
  checkboxes.forEach((checkbox) => {
    if (checkbox.checked) {
      allowedCookies.push(checkbox.id);
    }
  });
  allowedCookies.push('cookie-set');
  Cookies.set('cookie-banner-seen', allowedCookies, { expires: 7 });
  // eslint-disable-next-line no-restricted-globals
  location.reload();
});
